import React, { useRef, useState } from "react";
import moment from "moment";
import "moment/locale/es";
import { useForm } from "../../hooks/useForm";
import axios from "axios";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es"; //idioma react-dateícker
import "react-datepicker/dist/react-datepicker.css";
import validator from "validator";
import Swal from "sweetalert2";
import Select from "react-select";
import { Editor, EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import urlSlug from "url-slug";

import "draft-js/dist/Draft.css";
registerLocale("es", es); //idioma react-dateícker
setDefaultLocale("es"); //idioma react-dateícker

const FormularioScreen = ({
  areasTematicas,
  tipoEvento,
  variablesEntorno,
  agendaMasterDirigidoA,
  // agendaMasterEtiqueta,
  agendaMasterLugarPucp,
  agendaMasterUnidad,
}) => {
  moment.locale("es");
  const [selectedAreasTematicas, setSelectedAreasTematicas] = useState([]);

  const [selectedDirigidoA, setSelectedDirigidoA] = useState([]);

  const [selectedUnidadOrganizadora, setSelectedUnidadOrganizadora] = useState(
    []
  );

  // const [selectedEtiquetas, setSelectedEtiquetas] = useState([]);

  const [state, setState] = useState({
    MasInformacion: [],
    diasEspecificos: [],
    rangosFechas: [],
    lugaresExternos: [],
    lugaresPucp: [],
    // unidadOrganizadora: [{ unidadOrganizadora: "" }],
    contactoEventoEmails: [
      { contactoEmail: "", contactoEmailDominio: "@pucp.edu.pe" },
    ],
    organizadoContactoEmails: [
      { contactoEmail: "", contactoEmailDominio: "@pucp.edu.pe" },
    ],
    contacto: [],
  });

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const {
    diasEspecificos,
    rangosFechas,
    MasInformacion,
    lugaresExternos,
    lugaresPucp,
    // unidadOrganizadora,
    // contactoEventoEmails,
    organizadoContactoEmails,
  } = state;

  const inputImagenDestacada = useRef(null);
  const inputDescargables = useRef(null);

  const tipoEventoOrdenado = tipoEvento.sort((a, b) => {
    if (a.Nombre > b.Nombre) {
      return 1;
    }
    if (a.Nombre < b.Nombre) {
      return -1;
    }
    return 0;
  });

  const handleChangeDiaEspecifico = (e, index, campo) => {
    const aux = [...diasEspecificos];
    aux[index] = { ...aux[index], [campo]: e };

    setState((s) => ({ ...s, diasEspecificos: aux }));
  };

  const handleChangeLugar = (e, index, tipo, campo) => {
    if (tipo === "externo") {
      const aux = [...lugaresExternos];
      aux[index] = { ...aux[index], [campo]: e.target.value };

      setState((s) => ({ ...s, lugaresExternos: aux }));
    }
    if (tipo === "PUCP") {
      const lugar = agendaMasterLugarPucp.find(
        (x) => x.strapiId.toString() === e.target.value
      );

      let auxLugar = {};
      if (lugar) auxLugar = { ...lugar, id: lugar.strapiId };

      const aux = [...lugaresPucp];
      aux[index] = { ...aux[index], [campo]: auxLugar };

      setState((s) => ({ ...s, lugaresPucp: aux }));
    }
  };

  const handleChangeRangosFechas = (e, index, campo) => {
    const aux = [...rangosFechas];
    aux[index] = { ...aux[index], [campo]: e };

    setState((s) => ({ ...s, rangosFechas: aux }));
  };

  const optionsAreasTematicas = areasTematicas.map((x) => ({
    label: x.Nombre,
    value: x.strapiId,
  }));

  const optionsDirigidoA = agendaMasterDirigidoA.map((x) => ({
    label: x.Nombre,
    value: x.strapiId,
  }));

  const optionsUnidades = agendaMasterUnidad.map((x) => ({
    label: x.nombre,
    value: x.strapiId,
  }));

  // const optionsEtiquetas = agendaMasterEtiqueta.map((x) => ({
  //   label: x.Nombre,
  //   value: x.strapiId,
  // }));

  const initialForm = {
    Titulo: "",
    tipo_evento: "",
    source: `api-agenda`,
    linkTransmisionEnVivo: "",
    contactoIdentificacion: "",
    contactoNombre: "",
    contactoEmail: "",
    contactoEmailDominio: "@pucp.edu.pe",
    contactoTelefono: "",
    // contactoEventoTelefono: "",
    // contactoSitioWeb: "",
    otrasInstituciones: "",
    organizadoPorContactoNombre: "",
    organizadoPorContactoCelular: "",
    Costo: "",
    LinkInscripcion: "",
    EventoDestacado: false,
    CostoPersonalizado: "",
    EstadoDeEvento: "REGISTRADO",
    Ticket: "",
    area_tematicas: [],
    slug: "",
    agenda_master_dirigido_as: [],
    ImagenDestacada: null,
    Descarga: null,
    published_at: null,
  };

  const [formValues, handleInputChange, reset] = useForm(initialForm);

  // Agrega este código para contar los tipos de evento únicos
  // const typesCount = new Set(formValues.area_tematicas.map(item => item.tipo_evento)).size;
  // console.log("Número de tipos de evento:", typesCount);

  const {
    Titulo,
    tipo_evento,
    linkTransmisionEnVivo,
    contactoIdentificacion,
    contactoNombre,
    contactoEmail,
    contactoEmailDominio,
    contactoTelefono,
    // contactoEventoTelefono,
    // contactoSitioWeb,
    otrasInstituciones,
    organizadoPorContactoNombre,
    organizadoPorContactoCelular,
    Costo,
    LinkInscripcion,
    CostoPersonalizado,
  } = formValues;

  const validForm = () => {
    let result = { isFormValid: true, error: "" };

    if (validator.isEmpty(contactoIdentificacion)) {
      result.isFormValid = false;
      result.error = `La identificacion es necesaria.\n`;
    }

    if (validator.isEmpty(contactoNombre)) {
      result.isFormValid = false;
      result.error = `${result.error} Los nombres del usuario que registra son necesarios.`;
    }

    if (!validator.isEmail(contactoEmail.trim() + contactoEmailDominio)) {
      result.isFormValid = false;
      result.error = `${result.error} El correo del usuario que registra no es valido.`;
    }

    if (validator.isEmpty(contactoTelefono)) {
      result.isFormValid = false;
      result.error = `${result.error} El teléfono del usuario que registra es necesario.`;
    }

    // contactoEventoEmails.map((x, i) => {
    //   if (!validator.isEmail(x.contactoEmail.trim() + x.contactoEmailDominio)) {
    //     result.isFormValid = false;
    //     result.error = `${result.error} El(Los) correo(s) de contacto ${
    //       i + 1
    //     } para el evento no es valido.`;
    //     return;
    //   }
    // });

    if (validator.isEmpty(Titulo)) {
      result.isFormValid = false;
      result.error = `${result.error} El nombre del evento es necesario.`;
    }

    if (
      validator.isLength(Titulo, {
        min: 101,
        max: undefined,
      })
    ) {
      result.isFormValid = false;
      result.error = `${result.error} El nombre del evento tiene un máximo de 100 caracteres.`;
    }

    if (
      validator.isLength(editorState.getCurrentContent().getPlainText(), {
        min: 3201,
        max: undefined,
      })
    ) {
      result.isFormValid = false;
      result.error = `${result.error} La descripción tiene un máximo de 3200 caracteres.`;
    }

    // if (validator.isEmpty(contactoEventoTelefono)) {
    //   result.isFormValid = false;
    //   result.error = `${result.error} El telefono de contacto para el evento es necesario.`;
    // }

    if (!diasEspecificos.length && !rangosFechas.length) {
      result.isFormValid = false;
      result.error = `${result.error} Es necesario tener al menos una fecha.`;
    }

    if (!lugaresExternos.length && !lugaresPucp.length) {
      result.isFormValid = false;
      result.error = `${result.error} Es necesario tener al menos un lugar.`;
    }

    if (validator.isEmpty(organizadoPorContactoNombre)) {
      result.isFormValid = false;
      result.error = `${result.error} La(s) persona(s) de contacto es un campo necesario.`;
    }

    organizadoContactoEmails.map((x, i) => {
      if (!validator.isEmail(x.contactoEmail.trim() + x.contactoEmailDominio)) {
        result.isFormValid = false;
        result.error = `${result.error} El(Los) correo(s) de contacto ${
          i + 1
        } no es(son) valido(s).`;
        return;
      }
    });

    if (validator.isEmpty(organizadoPorContactoCelular)) {
      result.isFormValid = false;
      result.error = `${result.error}  El celular del organizador es necesario.`;
    }

    if (formValues.ImagenDestacada) {
      let _URL = window.URL || window.webkitURL;
      let img = new Image();
      img.src = _URL.createObjectURL(formValues.ImagenDestacada);
      let ancho = 0;
      let alto = 0;
      img.onload = () => {
        ancho = img.width;
        alto = img.height;
      };

      if (
        formValues.ImagenDestacada.size > 4 * 1024 * 1024 ||
        ancho > 591 ||
        alto > 400
      ) {
        result.isFormValid = false;
        result.error = `${result.error}  Imagen destacada: El archivo debe ser una imagen en formato .jpg o .png
        y contar con las siguientes dimensiones: 591 pix x 400
        pix.`;
      }
    }

    if (formValues.Descarga) {
      for (let i = 0; i < formValues.Descarga.length; i++) {
        const file = formValues.Descarga[i];

        if (file.size > 3 * 1024 * 1024) {
          result.isFormValid = false;
          result.error = `${result.error}  Archivos Descargables como: Archivos o imágenes en formatos .jpg, .png o .pdf,
          que no superen las 3Mb.`;
          break;
        }
      }
    }

    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = validForm();
    if (result.isFormValid) {
      const contactoRegistraEvento = {
        contactoIdentificacion,
        contactoNombre,
        contactoEmail: contactoEmail.trim() + contactoEmailDominio,
        contactoTelefono,
      };

      // const contactoEvento = {
      //   contactoEventoEmails: contactoEventoEmails
      //     .filter((x) => x.contactoEmail.trim().length > 0)
      //     .map((x) => {
      //       return {
      //         contactoEmail: x.contactoEmail.trim() + x.contactoEmailDominio,
      //       };
      //     }),
      //   contactoEventoTelefono,
      //   contactoSitioWeb,
      // };

      const organizadoPor = {
        otrasInstituciones,
        // unidadOrganizadora,
        contactoNombre: organizadoPorContactoNombre,
        contactoCelular: organizadoPorContactoCelular,
        contactoEventoCorreo: organizadoContactoEmails
          .filter((x) => x.contactoEmail.trim().length > 0)
          .map((x) => {
            return {
              contactoEmail: x.contactoEmail.trim() + x.contactoEmailDominio,
            };
          }),
      };
      const newSlug =
        urlSlug(Titulo) + "-" + moment(new Date()).format("DDMMYYYYHHmmss");

      const newTipoEvento = tipoEventoOrdenado.find(
        (t) => t.id === tipo_evento
      );

      const auxTipoEvento = newTipoEvento && {
        ...newTipoEvento,
        id: newTipoEvento.strapiId,
      };

      const auxCosto = Costo === "" ? null : Costo;

      const areasIds = selectedAreasTematicas.map((s) => s.value);
      const newAreasTematicas = areasTematicas
        .filter((t) => areasIds.includes(t.strapiId))
        .map((x) => ({ ...x, id: x.strapiId }));

      const dirigidoAIds = selectedDirigidoA.map((s) => s.value);
      const newDirigidoA = agendaMasterDirigidoA
        .filter((t) => dirigidoAIds.includes(t.strapiId))
        .map((x) => ({ ...x, id: x.strapiId }));

      const unidadOrganizadoraIds = selectedUnidadOrganizadora.map(
        (s) => s.value
      );
      const newUnidadOrganizadora = agendaMasterUnidad
        .filter((t) => unidadOrganizadoraIds.includes(t.strapiId))
        .map((x) => ({ ...x, id: x.strapiId }));

      // const etiquetasIds = selectedEtiquetas.map((s) => s.value);
      // const newEtiquetas = agendaMasterEtiqueta
      //   .filter((t) => etiquetasIds.includes(t.strapiId))
      //   .map((x) => ({ ...x, id: x.strapiId }));

      const newFechas = diasEspecificos.map((dia) => ({
        __component: "frecuencia.dia-especifico",
        Fecha: moment(dia.fecha).format("YYYY-MM-DD"),
        Inicio: moment(dia.inicio).format("HH:mm:ss.SSS"),
        Fin: moment(dia.fin).format("HH:mm:ss.SSS"),
      }));

      const rangos = rangosFechas.map((rango) => {
        console.log(
          `fecha utc inicio :${moment(rango.inicio)
            .utc()
            .format()} fin: ${moment(rango.fin).utc().format()}`
        );
        return {
          __component: "frecuencia.rango",
          Inicio: moment(rango.inicio).utc().format(),
          Fin: moment(rango.fin).utc().format(),
        };
      });

      const newLugares1 = lugaresExternos.map((x) => ({
        __component: "lugar.externo",
        Ubicacion: x.Ubicacion,
      }));
      const newLugares2 = lugaresPucp
        .filter((x) => x.agenda_master_lugar_pucp.strapiId !== "")
        .map((x) => ({
          __component: "lugar.pucp",
          agenda_master_lugar_pucp: x.agenda_master_lugar_pucp,
        }));

      let html = stateToHTML(editorState.getCurrentContent());

      Swal.fire({
        title: "Espere...",
        showConfirmButton: false,
        allowOutsideClick: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      // const jwt =null;
      let jwt;
      try {
        jwt = await axios({
          method: "post",
          url: `${variablesEntorno.AGENDA_APP_SITE}/auth/local`,
          data: {
            identifier: "apiToken",
            password: "Admin456",
          },
        });
      } catch (error) {
        Swal.fire(
          "Error al obtener token",
          `No se pudo conectar a ${variablesEntorno.AGENDA_APP_SITE}/auth/local. ${error.message}`,
          "error"
        );
        return;
      }

      var { Descarga, ImagenDestacada, ...newFormValues } = formValues;

      const data = {
        ...newFormValues,
        slug: newSlug,
        tipo_evento: auxTipoEvento,
        agenda_master_dirigido_as: newDirigidoA,
        Fechas: newFechas.concat(rangos),
        area_tematicas: newAreasTematicas,
        // agenda_master_etiquetas: newEtiquetas,
        agenda_master_unidads: newUnidadOrganizadora,
        MasInformacion: MasInformacion,
        Lugar: newLugares1.concat(newLugares2),
        Costo: auxCosto,
        contactoRegistraEvento,
        // contactoEvento,
        organizadoPor,
        Descripcion: html,
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      formData.append("files.ImagenDestacada", ImagenDestacada);

      if (Descarga) {
        for (let i = 0; i < Descarga.length; i++) {
          const file = Descarga[i];

          formData.append("files.Descarga", file);
        }
      }

      if (jwt.status === 200) {
        try {
          const addResult = await axios({
            method: "post",
            url: `${variablesEntorno.AGENDA_APP_SITE}/agenda-eventos`,
            data: formData,
            headers: {
              Authorization: `Bearer ${jwt.data.jwt}`,
            },
          });
          if (addResult.status === 200) {
            Swal.fire(
              "Evento creado",
              "El evento fue creado con éxito",
              "success"
            );
          } else {
            Swal.fire(
              `Error : ${addResult.status}`,
              `${addResult.statusText}`,
              "error"
            );
          }
          inputImagenDestacada.current.value = "";
          inputDescargables.current.value = "";
          reset();
          setSelectedAreasTematicas([]);
          setSelectedDirigidoA([]);
          // setSelectedEtiquetas([]);
          setEditorState(() => EditorState.createEmpty());
          setState((s) => ({
            ...s,
            MasInformacion: [],
            diasEspecificos: [],
            rangosFechas: [],
            lugaresExternos: [],
            // unidadOrganizadora: [{ unidadOrganizadora: "" }],
            // contactoEventoEmails: [
            //   { contactoEmail: "", contactoEmailDominio: "@pucp.edu.pe" },
            // ],
            organizadoContactoEmails: [
              { contactoEmail: "", contactoEmailDominio: "@pucp.edu.pe" },
            ],
          }));
        } catch (error) {
          Swal.fire(`Error`, `${error}`, "error");
        }
      }
    } else {
      Swal.fire("Error", result.error, "error");
    }
  };

  const handleFileChange = (e, campo) => {
    const file = e.target.files[0];

    if (file) {
      handleInputChange({ target: { name: campo, value: file } });
    }
  };
  const handleFilesChange = (e, campo) => {
    const files = e.target.files;

    if (files) {
      handleInputChange({ target: { name: campo, value: files } });
    }
  };

  const handleMasInformacionChange = (e, index, campo) => {
    const aux = [...MasInformacion];
    aux[index] = { ...aux[index], [campo]: e.target.value };

    setState((s) => ({ ...s, MasInformacion: aux }));
  };

  // const handleUnidadOrganizadoraChange = (e, index, campo) => {
  //   const aux = [...unidadOrganizadora];
  //   aux[index] = { ...aux[index], [campo]: e.target.value };

  //   setState((s) => ({ ...s, unidadOrganizadora: aux }));
  // };

  // const handleContactoEventoEmailChange = (e, index, campo) => {
  //   const aux = [...contactoEventoEmails];
  //   aux[index] = { ...aux[index], [campo]: e.target.value };

  //   setState((s) => ({ ...s, contactoEventoEmails: aux }));
  // };
  const handleOrganizadoContactoEmailsChange = (e, index, campo) => {
    const aux = [...organizadoContactoEmails];
    aux[index] = { ...aux[index], [campo]: e.target.value };

    setState((s) => ({ ...s, organizadoContactoEmails: aux }));
  };

  return (
    <>
      <div className="body">
        <div className="cuerpo">
          <div className="formato">
            <div className="user-cas-grande">
              <div className="clear cero"></div>
            </div>

            <p>
              La información que usted complete llegará a los editores de
              PuntoEdu impreso y web, así como al área de prensa externa,
              publicidad, agenda y redes sociales de la Universidad. Basta con
              llenar solo un formulario.
            </p>
            <ul>
              <li>
                Envíe la información hasta 15 días hábiles antes del inicio del
                evento.
              </li>
              <li>
                Al completarlo recibirá un correo de confirmación con los datos
                del evento.
              </li>
            </ul>
            <div className="form-wrapper">
              <form
                id="formularito"
                onSubmit={handleSubmit}
                className="search-top w-form"
              >
                <h2>Datos del usuario que registra</h2>
                <div className="form-content">
                  <div>
                    <div className="izq label">Identificacion*</div>
                    <div className="izq">
                      <select
                        name="contactoIdentificacion"
                        className="llarg"
                        onChange={handleInputChange}
                        value={contactoIdentificacion}
                      >
                        <option disabled value="">
                          Selecciona una identificación
                        </option>
                        <option value="Alumno">Alumno</option>
                        <option value="Profesor">Profesor</option>
                        <option value="Administrativo">Administrativo</option>
                      </select>
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor seleccione la identificación.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Nombres y apellidos *</div>
                    <div className="izq">
                      <input
                        className="texto"
                        type="text"
                        name="contactoNombre"
                        value={contactoNombre}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque sus nombres y apellidos.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Correo*</div>

                    <div className="izq separacion-simple">
                      <div className="w400">
                        <input
                          className="texto mail izq"
                          type="text"
                          name="contactoEmail"
                          value={contactoEmail}
                          onChange={handleInputChange}
                        />
                        <select
                          name="contactoEmailDominio"
                          className="tipo-mail izq"
                          value={contactoEmailDominio}
                          onChange={handleInputChange}
                        >
                          <option value="@pucp.edu.pe">@pucp.edu.pe</option>
                          <option value="@pucp.pe">@pucp.pe</option>
                        </select>

                        <div className="clear cero"></div>
                      </div>

                      <div className="clear cero" id="aqui-mails"></div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Teléfono/anexo*</div>
                    <div className="izq">
                      <input
                        className="texto"
                        type="text"
                        name="contactoTelefono"
                        value={contactoTelefono}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque su Teléfono o anexo.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>
                </div>

                {/* <h2>Datos de contacto para el evento:</h2>
                <div className="form-content">
                  <div>
                    <div className="izq label">Correo(s)*</div>

                    <div className="izq separacion-simple">
                      {contactoEventoEmails.map((x, i) => (
                        <div
                          key={i}
                          className="w400"
                          style={{ marginTop: "12px" }}
                        >
                          <input
                            className="texto mail izq"
                            type="text"
                            name="contact"
                            value={x.contactoEmail}
                            onChange={(e) =>
                              handleContactoEventoEmailChange(
                                e,
                                i,
                                "contactoEmail"
                              )
                            }
                          />
                          <select
                            name="contactoEventoEmailDominio"
                            className="tipo-mail izq"
                            value={x.contactoEmailDominio}
                            onChange={(e) =>
                              handleContactoEventoEmailChange(
                                e,
                                i,
                                "contactoEmailDominio"
                              )
                            }
                          >
                            <option value="@pucp.edu.pe">@pucp.edu.pe</option>
                            <option value="@pucp.pe">@pucp.pe</option>
                          </select>

                          {i > 0 ? (
                            <div className="remove-mail">
                              <a
                                className="una-mas eliminar-mail"
                                onClick={() => {
                                  const auxIndex = contactoEventoEmails.indexOf(
                                    x
                                  );

                                  if (auxIndex !== -1) {
                                    const auxArray = [...contactoEventoEmails];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      contactoEventoEmails: [...auxArray],
                                    }));
                                  }
                                }}
                              >
                                Eliminar correo
                              </a>
                            </div>
                          ) : (
                            <div className="add-mail">
                              <a
                                className="una-mas"
                                id="agregar-mail"
                                onClick={() => {
                                  setState((s) => ({
                                    ...s,
                                    contactoEventoEmails: [
                                      ...contactoEventoEmails,
                                      {
                                        contactoEmail: "",
                                        contactoEmailDominio: "@pucp.edu.pe",
                                      },
                                    ],
                                  }));
                                }}
                              >
                                Agregar correo
                              </a>
                            </div>
                          )}

                          <div className="clear cero"></div>
                        </div>
                      ))}
                    </div>

                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Teléfono(s)*</div>
                    <div className="izq separacion-simple">
                      <input
                        className="texto"
                        type="tel"
                        name="contactoEventoTelefono"
                        value={contactoEventoTelefono}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque el teléfono y/o anexo de la Unidad.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Sitio web</div>
                    <div className="izq separacion-simple">
                      <input
                        className="texto"
                        type="text"
                        name="contactoSitioWeb"
                        value={contactoSitioWeb}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque un sitio web.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <h3 className="h3-formulario subte">
                    Solo para uso exclusivo módulo de visitas PUCP (OCAI) *
                  </h3>
                </div> */}

                <h2>Datos del evento:</h2>
                <div className="form-content">
                  <div>
                    <div className="izq label">
                      Nombre del evento*
                      <div className="mini">(máx. 100 caracteres)</div>
                    </div>
                    <div className="izq">
                      <input
                        type="text"
                        className="texto"
                        maxLength="256"
                        placeholder="Nombre del evento"
                        name="Titulo"
                        value={Titulo}
                        onChange={handleInputChange}
                      />

                      <div className="error-espacio">
                        <span className="conta-txt">
                          Caracteres:
                          {Titulo.length}
                        </span>

                        <div className="clear cero"></div>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">
                      Descripci&oacute;n
                      <div className="mini">(máx. 3200 caracteres)</div>
                    </div>
                    <div className="izq">
                      <Editor
                        editorState={editorState}
                        onChange={setEditorState}
                        placeholder="Descripcion"
                      />

                      <div
                        className="charleft hidden"
                        style={{ width: "480px" }}
                      >
                        &nbsp;
                      </div>
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque la descripción del evento. |
                        </span>
                        <span className="conta-txt">
                          Caracteres:{" "}
                          {
                            editorState.getCurrentContent().getPlainText()
                              .length
                          }
                        </span>
                        <input
                          readOnly="readonly"
                          type="hidden"
                          className="conta"
                          name="conta"
                          value="Palabras: 0"
                        />
                        <div className="clear cero"></div>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">
                      Fecha y hora*
                      <div className="mini">
                        (da clic en la opción que describe tu evento)
                      </div>
                    </div>

                    <div className="izq separacion-simple">
                      <div className="fecha-opcion fecha-1">
                        {diasEspecificos.map((f, i) => {
                          return (
                            <div key={i}>
                              <div className="col-fecha col-1 izq">
                                <div className="titu">Fecha</div>
                                <DatePicker
                                  className="kurt fechita hasDatepicker"
                                  dateFormat="dd/MM/yy"
                                  selected={f.fecha}
                                  onChange={(date) => {
                                    handleChangeDiaEspecifico(date, i, "fecha");
                                  }}
                                />
                              </div>
                              <div className="col-fecha col-2 izq">
                                <div className="titu">Hora de inicio</div>
                                <DatePicker
                                  className="kurt fechita hasDatepicker"
                                  selected={f.inicio}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  onChange={(date) => {
                                    handleChangeDiaEspecifico(
                                      date,
                                      i,
                                      "inicio"
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-fecha col-3 izq">
                                <div className="titu">Hora de fin</div>
                                <DatePicker
                                  className="kurt fechita hasDatepicker"
                                  selected={f.fin}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  onChange={(date) => {
                                    handleChangeDiaEspecifico(date, i, "fin");
                                  }}
                                />
                              </div>
                              <div className="my-delete-div-fechas">
                                <a
                                  className="my-delete-icon-button"
                                  onClick={() => {
                                    const auxIndex = diasEspecificos.indexOf(f);

                                    if (auxIndex !== -1) {
                                      const auxArray = [...diasEspecificos];
                                      auxArray.splice(auxIndex, 1);
                                      setState((s) => ({
                                        ...s,
                                        diasEspecificos: [...auxArray],
                                      }));
                                    }
                                  }}
                                ></a>
                              </div>
                            </div>
                          );
                        })}
                        <div className="clear cero"></div>
                      </div>

                      <div className="add-red">
                        <a
                          type="button"
                          className="una-mas una-red-mas"
                          id="agregar-red"
                          onClick={() => {
                            setState((s) => ({
                              ...s,
                              diasEspecificos: [
                                ...diasEspecificos,
                                {
                                  fecha: new Date(),
                                  inicio: new Date(),
                                  fin: new Date(),
                                },
                              ],
                            }));
                          }}
                        >
                          Agregar dia especifico
                        </a>
                      </div>

                      <div
                        className="fecha-opcion fecha-1"
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        {rangosFechas.map((f, i) => {
                          return (
                            <div key={i}>
                              <div className="col-fecha col-2 izq">
                                <div className="titu"> Fecha de inicio</div>
                                <DatePicker
                                  className="kurt fechita hasDatepicker"
                                  dateFormat="dd/MM/yy h:mm aa"
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={15}
                                  timeCaption="time"
                                  selected={f.inicio}
                                  onChange={(date) => {
                                    handleChangeRangosFechas(date, i, "inicio");
                                  }}
                                />
                              </div>
                              <div className="col-fecha col-2 izq">
                                <div className="titu">Fecha de fin</div>
                                <DatePicker
                                  className="kurt fechita hasDatepicker"
                                  dateFormat="dd/MM/yy h:mm aa"
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={15}
                                  timeCaption="time"
                                  selected={f.fin}
                                  onChange={(date) => {
                                    handleChangeRangosFechas(date, i, "fin");
                                  }}
                                />
                              </div>
                              <div className="my-delete-div-fechas">
                                <a
                                  className="my-delete-icon-button"
                                  onClick={() => {
                                    const auxIndex = rangosFechas.indexOf(f);

                                    if (auxIndex !== -1) {
                                      const auxArray = [...rangosFechas];
                                      auxArray.splice(auxIndex, 1);
                                      setState((s) => ({
                                        ...s,
                                        rangosFechas: [...auxArray],
                                      }));
                                    }
                                  }}
                                ></a>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div className="add-red">
                        <a
                          type="button"
                          className="una-mas una-red-mas"
                          onClick={() => {
                            setState((s) => ({
                              ...s,
                              rangosFechas: [
                                ...rangosFechas,
                                {
                                  fecha: new Date(),
                                  inicio: new Date(),
                                  fin: new Date(),
                                },
                              ],
                            }));
                          }}
                        >
                          Agregar rango de fechas
                        </a>
                      </div>
                    </div>

                    <div className="clear cero"></div>
                  </div>

                  {/* <div>
                    <div className="izq label">Nombre del evento*</div>
                    <div className="izq">
                      <input
                        type="text"
                        className="texto"
                        maxLength="256"
                        placeholder="Nombre del evento"
                        name="Titulo"
                        value={Titulo}
                        onChange={handleInputChange}
                      />

                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque sus nombres.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div> */}

                  <div>
                    <div className="izq label">Dirigido A</div>
                    <div className="izq separacion-simple">
                      <Select
                        placeholder="Selecciona los p&uacute;blicos"
                        isMulti
                        options={optionsDirigidoA}
                        className="my-multi-select"
                        onChange={setSelectedDirigidoA}
                        value={selectedDirigidoA}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Lugar*</div>
                    <div className="izq separacion-simple">
                      <div className="fecha-opcion fecha-1">
                        {lugaresExternos.map((l, i) => (
                          <div
                            key={i}
                            style={i > 0 ? { marginTop: "20px" } : {}}
                          >
                            <div className="izq">
                              <input
                                type="text"
                                className="my-texto-delete"
                                maxLength="256"
                                placeholder="Lugar externo"
                                name="Lugar"
                                value={l.Ubicacion}
                                onChange={(e) => {
                                  handleChangeLugar(
                                    e,
                                    i,
                                    "externo",
                                    "Ubicacion"
                                  );
                                }}
                              />
                            </div>
                            <div className="my-delete-div">
                              <a
                                className="my-delete-icon-button"
                                onClick={() => {
                                  const auxIndex = lugaresExternos.indexOf(l);

                                  if (auxIndex !== -1) {
                                    const auxArray = [...lugaresExternos];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      lugaresExternos: [...auxArray],
                                    }));
                                  }
                                }}
                              ></a>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="add-red">
                        <a
                          type="button"
                          className="una-mas una-red-mas"
                          onClick={() => {
                            setState((s) => ({
                              ...s,
                              lugaresExternos: [
                                ...lugaresExternos,
                                {
                                  Ubicacion: "",
                                },
                              ],
                            }));
                          }}
                        >
                          Agregar lugar externo
                        </a>
                      </div>

                      <div
                        className="fecha-opcion fecha-1"
                        style={{ marginTop: "12px" }}
                      >
                        {lugaresPucp.map((l, i) => (
                          <div
                            key={i}
                            style={i > 0 ? { marginTop: "20px" } : {}}
                          >
                            <div className="izq">
                              <select
                                className="llarg my-llarg"
                                onChange={(e) => {
                                  handleChangeLugar(
                                    e,
                                    i,
                                    "PUCP",
                                    "agenda_master_lugar_pucp"
                                  );
                                }}
                                // defaultValue=""
                                value={l.agenda_master_lugar_pucp.strapiId}
                              >
                                <option value="">
                                  Selecciona un lugar PUCP
                                </option>
                                {agendaMasterLugarPucp.map((te) => (
                                  <option key={te.id} value={te.strapiId}>
                                    {te.Nombre}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="my-delete-div">
                              <a
                                className="my-delete-icon-button"
                                onClick={() => {
                                  const auxIndex = lugaresPucp.indexOf(l);

                                  if (auxIndex !== -1) {
                                    const auxArray = [...lugaresPucp];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      lugaresPucp: [...auxArray],
                                    }));
                                  }
                                }}
                              ></a>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="add-red">
                        <a
                          type="button"
                          className="una-mas una-red-mas"
                          onClick={() => {
                            setState((s) => ({
                              ...s,
                              lugaresPucp: [
                                ...lugaresPucp,
                                {
                                  agenda_master_lugar_pucp: {
                                    strapiId: "",
                                  },
                                },
                              ],
                            }));
                          }}
                        >
                          Agregar lugar PUCP
                        </a>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <h3 className="h3-formulario">Organizado por*</h3>
                  <div>
                    <div className="izq label subte">Unidad organizadora</div>

                    <div className="izq separacion-simple">
                      <Select
                        placeholder="Selecciona la(s) unidad(es)"
                        isMulti
                        options={optionsUnidades}
                        className="my-multi-select"
                        onChange={setSelectedUnidadOrganizadora}
                        value={selectedUnidadOrganizadora}
                      />
                    </div>
                    <div className="clear cero"></div>

                    {/* <div className="izq separacion-simple">
                      {unidadOrganizadora.map((x, i) => (
                        <div
                          key={i}
                          className="w400"
                          style={{ marginTop: "12px" }}
                        >
                          <input
                            className="texto izq my-text-unidad-organizadora"
                            type="text"
                            name="unidadOrganizadora"
                            value={x.unidadOrganizadora}
                            onChange={(e) =>
                              handleUnidadOrganizadoraChange(
                                e,
                                i,
                                "unidadOrganizadora"
                              )
                            }
                          />
                          {i > 0 ? (
                            <div className="remove-mail">
                              <a
                                className="una-mas eliminar-mail"
                                onClick={() => {
                                  const auxIndex =
                                    unidadOrganizadora.indexOf(x);

                                  if (auxIndex !== -1) {
                                    const auxArray = [...unidadOrganizadora];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      unidadOrganizadora: [...auxArray],
                                    }));
                                  }
                                }}
                              >
                                Eliminar unidad
                              </a>
                            </div>
                          ) : (
                            <div className="add-mail">
                              <a
                                className="una-mas"
                                id="agregar-mail"
                                onClick={() => {
                                  setState((s) => ({
                                    ...s,
                                    unidadOrganizadora: [
                                      ...unidadOrganizadora,
                                      {
                                        unidadOrganizadora: "",
                                      },
                                    ],
                                  }));
                                }}
                              >
                                Agregar unidad
                              </a>
                            </div>
                          )}

                          <div className="clear cero"></div>
                        </div>
                      ))}

                      <div className="clear cero" id="aqui-mails"></div>
                    </div>

                    <div className="clear cero"></div> */}
                  </div>

                  <div>
                    <div className="izq label subte">Otras instituciones
                      <div className="mini">
                        <p style={{ margin: "0px", paddingBottom: "20px"}}>
                          (maximo de 255 carcteres)
                        </p>
                      </div>
                    </div>

                    <div className="izq separacion-simple">
                      <input
                        className="texto"
                        type="text"
                        name="otrasInstituciones"
                        value={otrasInstituciones}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label subte">
                      Persona(s) de contacto*
                    </div>
                    <div className="izq">
                      <input
                        className="texto"
                        type="text"
                        name="organizadoPorContactoNombre"
                        value={organizadoPorContactoNombre}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque el nombre de la persona de contacto.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label subte">
                      Correo(s) de contacto*
                    </div>

                    <div className="izq separacion-simple">
                      {organizadoContactoEmails.map((x, i) => (
                        <div
                          key={i}
                          className="w400"
                          style={{ marginTop: "12px" }}
                        >
                          <input
                            className="texto mail izq"
                            type="text"
                            name="contact"
                            value={x.contactoEmail}
                            onChange={(e) =>
                              handleOrganizadoContactoEmailsChange(
                                e,
                                i,
                                "contactoEmail"
                              )
                            }
                          />
                          <select
                            name="contactoEventoEmailDominio"
                            className="tipo-mail izq"
                            value={x.contactoEmailDominio}
                            onChange={(e) =>
                              handleOrganizadoContactoEmailsChange(
                                e,
                                i,
                                "contactoEmailDominio"
                              )
                            }
                          >
                            <option value="@pucp.edu.pe">@pucp.edu.pe</option>
                            <option value="@pucp.pe">@pucp.pe</option>
                          </select>

                          {i > 0 ? (
                            <div className="remove-mail">
                              <a
                                className="una-mas eliminar-mail"
                                onClick={() => {
                                  const auxIndex =
                                    organizadoContactoEmails.indexOf(x);

                                  if (auxIndex !== -1) {
                                    const auxArray = [
                                      ...organizadoContactoEmails,
                                    ];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      organizadoContactoEmails: [...auxArray],
                                    }));
                                  }
                                }}
                              >
                                Eliminar correo
                              </a>
                            </div>
                          ) : (
                            <div className="add-mail">
                              <a
                                className="una-mas"
                                id="agregar-mail"
                                onClick={() => {
                                  setState((s) => ({
                                    ...s,
                                    organizadoContactoEmails: [
                                      ...organizadoContactoEmails,
                                      {
                                        contactoEmail: "",
                                        contactoEmailDominio: "@pucp.edu.pe",
                                      },
                                    ],
                                  }));
                                }}
                              >
                                Agregar correo
                              </a>
                            </div>
                          )}

                          <div className="clear cero"></div>
                        </div>
                      ))}
                    </div>

                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label subte">Celular*</div>
                    <div className="izq">
                      <input
                        className="texto"
                        type="text"
                        name="organizadoPorContactoCelular"
                        value={organizadoPorContactoCelular}
                        onChange={handleInputChange}
                      />
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor coloque el celular de la persona de
                          contacto.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>
                </div>

                <h2>Datos adicionales</h2>
                <div className="form-content">
                  <div>
                    <div className="izq label">Tipo de evento*</div>
                    <div className="izq">
                      <select
                        name="tipo_evento"
                        className="llarg"
                        onChange={handleInputChange}
                        value={tipo_evento}
                      >
                        <option disabled value="">
                          Selecciona un tipo
                        </option>
                        {tipoEventoOrdenado.map((te) => (
                          <option key={te.id} value={te.id}>
                            {te.Nombre}
                          </option>
                        ))}
                      </select>
                      <div className="error-espacio">
                        <span className="error-txt">
                          Por favor seleccione el tipo de evento.
                        </span>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Tema</div>
                    <div className="izq separacion-simple">
                      <Select
                        placeholder="Selecciona los temas"
                        isMulti
                        options={optionsAreasTematicas}
                        className="my-multi-select"
                        onChange={setSelectedAreasTematicas}
                        value={selectedAreasTematicas}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  {/* <div>
                    <div className="izq label">Etiquetas</div>
                    <div className="izq separacion-simple">
                      <Select
                        placeholder="Selecciona las etiquetas"
                        isMulti
                        options={optionsEtiquetas}
                        className="my-multi-select"
                        onChange={setSelectedEtiquetas}
                        value={selectedEtiquetas}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div> */}

                  <div>
                    <div className="izq label">Costo del evento</div>
                    <div className="izq separacion-simple">
                      <select
                        name="Costo"
                        className="llarg"
                        onChange={handleInputChange}
                        value={Costo}
                      >
                        <option disabled value="">
                          Selecciona un costo
                        </option>
                        <option value="GratuitoIngresoLibre">
                          Ingreso libre
                        </option>
                        <option value="GratuitoIngresoConRegistro">
                          Ingreso libre previo registro
                        </option>
                        <option value="costo">Evento pago</option>
                      </select>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Costo personalizado</div>
                    <div className="izq separacion-simple">
                      <input
                        type="text"
                        className="texto"
                        maxLength="256"
                        placeholder="Costo personalizado"
                        name="CostoPersonalizado"
                        value={CostoPersonalizado}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">Link para registrarse</div>
                    <div className="izq separacion-simple">
                      <input
                        type="text"
                        className="texto"
                        maxLength="256"
                        placeholder="Link de inscripcion"
                        name="LinkInscripcion"
                        value={LinkInscripcion}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div>
                    <div className="izq label">
                      Transmisión en vivo
                      <div className="mini">
                        (Colocar el link hacia la transmisión)
                      </div>
                    </div>
                    <div className="izq separacion-simple">
                      <input
                        className="texto"
                        type="text"
                        name="linkTransmisionEnVivo"
                        value={linkTransmisionEnVivo}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  {/* <div className="descargables">
                    <div className="izq label">
                      Archivos descargables
                      <div className="mini">
                        (peso máximo total de archivos: 4MB)
                      </div>
                    </div>
                    <div className="izq separacion-simple">
                      <div className="fecha-opcion archivos">
                        <div className="cada-archivo">
                          <div className="el-archivo">
                            <input
                              className="archivo tete0"
                              type="file"
                              name="archivo[]"
                            />
                          </div>
                          <div className="nuevo-nombre">
                            <div className="titu izq">Nombre del archivo</div>
                            <input
                              className="der el-nombre"
                              type="text"
                              name="archivo-nombre[]"
                            />
                            <div className="clear cero"></div>
                          </div>
                        </div>
                        <div className="add-file">
                          <a className="una-mas izq" id="agregar-archivo">
                            Agregar otro archivo
                          </a>
                        </div>
                        <input
                          name="peso"
                          type="text"
                          id="pesos"
                          className="pesos der"
                          readonly="readonly"
                          value="Peso total: 0.00 MB"
                        />
                        <div className="clear cero"></div>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div> */}

                  <div>
                    <div className="izq label">Canales de información</div>
                    <div className="izq separacion-simple">
                      {MasInformacion.map((m, i) => {
                        return (
                          <div
                            key={i}
                            className="fecha-opcion datos-inscripciones"
                            style={i > 0 ? { marginTop: "20px" } : {}}
                          >
                            <div className="col-fecha col-1 izq">
                              <div className="titu">Tipo de canal</div>
                              <select
                                onChange={(e) =>
                                  handleMasInformacionChange(e, i, "TipoLink")
                                }
                                value={m.TipoLink}
                              >
                                {/* <option disabled value="">
                                      Selecciona un tipo de link
                                    </option> */}

                                <option value="Web">Web</option>
                                <option value="Correo">Correo</option>
                                <option value="Facebook">Facebook</option>
                                <option value="Twitter">Twitter</option>
                                <option value="Instagram">Instagram</option>
                                <option value="LinkedIn">LinkedIn</option>
                              </select>
                            </div>

                            <div className="col-fecha col-5 izq">
                              <div className="titu">Link de canal</div>
                              <input
                                type="text"
                                className="my-new-link-red"
                                maxLength="256"
                                placeholder="Link"
                                value={m.Link}
                                onChange={(e) =>
                                  handleMasInformacionChange(e, i, "Link")
                                }
                              />
                            </div>

                            <div className="col-fecha col-5 izq">
                              <div className="titu">Nombre de canal</div>

                              <input
                                type="text"
                                className="my-new-link-red"
                                maxLength="256"
                                placeholder="Ejemplo: Facebook - Dirección de Comunicación Institucionals"
                                value={m.Descripcion}
                                onChange={(e) =>
                                  handleMasInformacionChange(
                                    e,
                                    i,
                                    "Descripcion"
                                  )
                                }
                              />
                            </div>

                            <div className="my-delete-div-tpo">
                              <a
                                className="my-delete-icon-button"
                                onClick={() => {
                                  const auxIndex = MasInformacion.indexOf(m);

                                  if (auxIndex !== -1) {
                                    const auxArray = [...MasInformacion];
                                    auxArray.splice(auxIndex, 1);
                                    setState((s) => ({
                                      ...s,
                                      MasInformacion: [...auxArray],
                                    }));
                                  }
                                }}
                              ></a>
                            </div>

                            <div className="clear cero"></div>
                          </div>
                        );
                      })}

                      <div className="add-red">
                        <a
                          type="button"
                          className="una-mas una-red-mas"
                          id="agregar-red"
                          onClick={() => {
                            setState((s) => ({
                              ...s,
                              MasInformacion: [
                                ...MasInformacion,
                                {
                                  Link: "",
                                  TipoLink: "Web",
                                  Descripcion: "",
                                },
                              ],
                            }));
                          }}
                        >
                          Agregar otro canal de información
                        </a>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div className="descargables">
                    <div className="izq label">
                      Imagen destacada
                      <div className="mini">
                        {/* <p style={{ margin: "0px", padding: "5px" }}>
                          (El archivo debe ser una imagen en formato .jpg o .png
                          y contar con las siguientes dimensiones: 591 pix x 400
                          pix.)
                        </p> */}
                        <p style={{ margin: "0px", padding: "5px" }}>
                          El archivo debe ser una imagen en formato .jpg o .png. <strong style={{ color: "darkblue" }}>Tamaño exacto: 591 píxeles de ancho por 400 píxeles de alto</strong><br />
                        </p>
                      </div>
                    </div>
                    <div className="izq separacion-simple">
                      <div className="fecha-opcion archivos">
                        <input
                          ref={inputImagenDestacada}
                          className="archivo tete0"
                          type="file"
                          accept=".jpg,.png"
                          onChange={(e) => {
                            handleFileChange(e, "ImagenDestacada");
                          }}
                        />
                        {/* <div className="cada-archivo">
                          <div className="el-archivo">
                            <input
                              className="archivo tete0"
                              type="file"
                              name="archivo[]"
                            />
                          </div>
                          <div className="nuevo-nombre">
                            <div className="titu izq">Nombre del archivo</div>
                            <input
                              className="der el-nombre"
                              type="text"
                              name="archivo-nombre[]"
                            />
                            <div className="clear cero"></div>
                          </div>
                        </div> */}
                        <div className="clear cero"></div>
                      </div>
                      <p style={{color: "red", fontStyle: "italic", fontSize: "12px"}}>* La imagen no debe contener ningún texto, fecha, lugar ni logotipos</p>
                    </div>
                    <div className="clear cero"></div>
                  </div>

                  <div className="descargables">
                    <div className="izq label">
                      Archivos descargables
                      <div className="mini">
                        <p style={{ margin: "0px", padding: "5px" }}>
                          (Archivos o imágenes en formatos .jpg, .png o .pdf,
                          que no superen las 3MB.)
                        </p>
                      </div>
                    </div>
                    <div className="izq separacion-simple">
                      <div className="fecha-opcion archivos">
                        <input
                          ref={inputDescargables}
                          multiple
                          className="archivo tete0"
                          type="file"
                          accept=".jpg,.png,.pdf"
                          onChange={(e) => {
                            handleFilesChange(e, "Descarga");
                          }}
                        />
                        {/* <div className="cada-archivo">
                          <div className="el-archivo">
                            <input
                              multiple
                              className="archivo tete0"
                              type="file"
                              name="archivo[]"
                            />
                          </div>
                        </div> */}

                        <div className="clear cero"></div>
                      </div>
                    </div>
                    <div className="clear cero"></div>
                  </div>
                </div>

                <div className="acciones">
                  <input
                    className="enviar"
                    value="Enviar"
                    name="enviar"
                    type="submit"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormularioScreen;
